import React from "react"
import { PanelDialogue } from "../../common/PanelDialogue"
import { Comment } from "../../common/Comment";
import { useTranslation } from "react-i18next";


function FullCaseHistory(props){
    const { t } = useTranslation();
    const {open, closeFunction, caseId, caseComments} = props;
    const anchorEl = document.getElementById("full-history-button")

    return(
        <PanelDialogue 
            open={open} 
            title={`${t("CaseHistory")} - ${caseId}`} 
            cancelFunction={closeFunction} 
            showActionButtons={false}
            anchorEl={anchorEl}
        >
            <div style={{maxHeight: "30rem", overflowY: "auto", display: "flex", flexDirection: "column", rowGap: "1rem"}}>
                {caseComments?.map((comment, i, a)=>
                    <div key={`full-case-historic-${i}`}>
                        <Comment 
                            state={comment.state} 
                            titleFontSize={"1.25rem"}
                            agent={comment.agent} 
                            date={comment.date} 
                            message={comment.message}
                            key={comment.id}
                        />
                        </div>
                    )                       
                }
                    
            </div>

        </PanelDialogue>
    )
}

export {FullCaseHistory}